export default {
  epc: 'RFID EPC',
  scanResult: '检测结果',
  upc: 'UPC',
  style: 'Style',
  size: 'Size',
  markFor: 'Mark For',
  soldTo: 'Sold To',
  shipTo: 'Ship To',
  obScanTime: 'OB Time',
  obScanTimeForReport: '商品出库时间',
  scanRecord: '检测记录',
  total: '共',
  results: '个结果',
  operator: '操作人',
  gmScanTime: '商品扫描时间',
  qty: 'Qty',
  scan: '扫描',
  scanPlaceholder: '请扫描/输入RFID EPC',
  scanPlaceholderForWeb: '请输入RFID EPC',
  stopScan: '停止',
  devicePower: '手持枪功率',
  collapse: '收起',
  expand: '展开',
  error1500: 'EPC错误或不存在',
  scanQrPlaceholder: '请扫描/输入QR Code',
  scanQrPlaceholderForWeb: '请输入QR Code',
  invalidQRCodeFormat: '无效 QR Code格式，请再试一次。正确格式应为： HTTPS://QR.NIKE.COM/04B5Z1S0ERWR1。',
  tryAgain: '请再试一次。',
  qrCode: 'QR Code',
  switchTo: '切换',
  scanTips1: '*先扫GC本地二维码；无则扫Nike原厂二维码',
  scanTips2: '*继续扫描Nike原厂码；无则跳过，直接搜索',
  qrCodeTips1: 'GC本地二维码',
  qrCodeTips2: 'Nike原厂二维码',
  errorcode_5003: '仅支持以下二维码。',
  globalQrCode: 'Nike原厂二维码',
  localQrCode: 'GC本地二维码'
}
